! function(e) {
    function t() {
        switch (e.cookie("productsGridList")) {
            case "grid":
                e("#toggle_grid").addClass("active"), e("#toggle_list").removeClass("active"), e(".product_listing_main").removeClass("view_list");
                break;
            case "list":
                e("#toggle_grid").removeClass("active"), e("#toggle_list").addClass("active"), e(".product_listing_main").addClass("view_list");
                break;
            default:
                e.cookie("productsGridList", "grid", {
                    expires: 365
                })
        }
        e("#toggle_grid").on("click", function() {
            e.cookie("productsGridList", "grid", {
                expires: 365
            }), e(this).hasClass("active") || (e("#toggle_list").removeClass("active"), e(this).addClass("active"), e(".product_listing_main").removeClass("view_list"))
        }), e("#toggle_list").on("click", function() {
            e.cookie("productsGridList", "list", {
                expires: 365
            }), e(this).hasClass("active") || (e("#toggle_grid").removeClass("active"), e(this).addClass("active"), e(".product_listing_main").addClass("view_list"))
        })
    }

  
  	function sizeImages() {
      //console.log("SI init");
  		 var divs = $("div.product");
    		for(var i = 0; i < divs.length; i+=3) {
      			//divs.slice(i, i+3).wrapAll("<div class='new'></div>");
              //console.log($(this).height() );
              $( ".product_img img" ).each(function( index ) {
  					//console.log( index + ": " + $( this ).height() );
					});
    		}
	}
  
    function i(i, o) {
        function c() {
            e("#pagination a").each(function() {
                var a = e(this).attr("href").replace(/.*page=/, "").replace(/\&.*/, "");
                e(this).attr("href", s + "&page=" + a), e(this).click(function() {
                  
                  /*
                  console.log("p");
                  
                  $( ".product_img img" ).each(function( index ) {
  					console.log( index + ": " + $( this ).height() );
					});
                  
                  */
                  
                 
                  
                    return e("#collection_sorted").load(e(this).attr("href") + " #collection_sorted > *", function() {
                      
                      //console.log("a");
                  sizeImages();
          			 //height_handler();
          
          /*
                  $( ".product_img img" ).each(function( index ) {
  					console.log( index + ": " + $( this ).height() );
					});
                      
                      */
                        e.cookie("productsQuantity", i), e.cookie("productsSort", o), t(), c(), currencyToggle(), e("#product_listing_preloader").fadeOut(300), e("#collection_sorted").animate({
                            opacity: 1
                        }, 500)
                    }), !1
                })
            })
        }
        var s = window.location.toString();
        s = s.indexOf("view") > -1 ? s.replace(/.*view/, "").indexOf("&") > -1 ? s.replace(/view=.*?&/, "view=" + i + "&") : s.replace(/view=.*/, "view=" + i) : s.indexOf("?") > -1 ? s + "&view=" + i : s + "?view=" + i, s = s.indexOf("sort_by") > -1 ? s.replace(/.*sort_by/, "").indexOf("&") > -1 ? s.replace(/sort_by=.*?&/, "sort_by=" + o + "&") : s.replace(/sort_by=.*/, "sort_by=" + o) : s.indexOf("?") > -1 ? s + "&sort_by=" + o : s + "?sort_by=" + o, s.indexOf("page") > -1 ? s = s.replace(/.*page/, "").indexOf("&") > -1 ? s.replace(/page=.*?&/, "page=1&") : s.replace(/page=.*/, "page=1") : s += s.indexOf("?") > -1 ? "&page=1" : "?page=1", e("#product_listing_preloader").fadeIn(600), e("#collection_sorted").animate({
            opacity: 0
        }, 400), e("#collection_sorted").load(s + " #collection_sorted > *", function() {
          	
          //console.log("b");
           sizeImages();       
          			 //height_handler();
          
          /*
                  $( ".product_img img" ).each(function( index ) {
  					console.log( index + ": " + $( this ).height() );
					});
          */
            e.cookie("productsQuantity", i), e.cookie("productsSort", o), t(), c(), currencyToggle(), e("#product_listing_preloader").fadeOut(300), e("#collection_sorted").animate({
                opacity: 1
            }, 500)
        })
    }

    function o(t) {
        e("#show_products_select option").each(function() {
            e(this).val() == t && e(this).attr("selected", "selected")
        })
    }

    function c(t) {
        e("#sort_by_select option").each(function() {
            e(this).val() == t && e(this).attr("selected", "selected")
        })
    }
    e("#product_listing_preloader").hide(), e(document).ready(function() {
        var s = e.cookie("productsQuantity"),
            a = e.cookie("productsSort");
        t(), s && a ? (i(s, a), o(s), c(a)) : s && !a ? (i(s, "manual"), o(s), c("manual")) : !s && a ? (i(6, a), o(6), c(a)) : (i(6, "manual"), o(6), c("manual")), e("#show_products_select").on("change", function() {
            i(e(this).val(), e("#sort_by_select").val())
        }), e("#sort_by_select").on("change", function() {
            i(e("#show_products_select").val(), e(this).val())
        })
    })
}(jQuery);